<template>
  <div class="product-detail">
    <div class="product-detail-box">
      <div class="product-detail-title">
        <img :src="url">
        <div class="info">
          <div class="info-title">{{ $t('productCenter.tabs.hgp') }}</div>
          <div class="info-text">{{ productDescription }}</div>
          <el-button 
            style="height: 43px;"
            type="primary" 
            @mouseenter.native="mouseenter" 
            @mouseleave.native="mouseleave"
          >
            {{ btnText }}
            <img 
              v-if="showcloudDownloadImg" 
              style="margin-right: 0;height: 15px;position: relative;top: 2px;" 
              :src="cloudDownload"
            >
          </el-button>
        </div>
      </div>
    </div>
    <div class="product-detail-info">
      <div class="list">
        <div class="list-title">{{ $t('productCenter.common.productFeatures') }}</div>
        <div class="list-item" v-for="feature in productFeatures" :key="feature"><span></span><p>{{ feature }}</p></div>
      </div>
          
      <div class="list">
        <div class="list-title">{{ $t('productCenter.common.typicalApplications') }}</div>
        <div class="list-item" v-for="application in typicalApplications" :key="application"><span></span><p>{{ application }}</p></div>
      </div>

      <div class="table">
        <div class="table-title">{{ $t('productCenter.common.technicalParameters') }}</div>
        <el-table
          :data="tableData"
          stripe
          border
          style="width: 100%">
            <el-table-column
              prop="project"
              :label="$t('productCenter.common.project')"
              width="118">
              <template slot-scope="scope">
                <span class="multiline">{{ scope.row.project.replace(/｜/g, '\n') }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="test"
              :label="$t('productCenter.common.testMethod')"
              align="center"
              width="137">
            </el-table-column>
            <el-table-column
              prop="parameter1"
              align="center"
              width="118"
              label="HGP1020">
            </el-table-column>
            <el-table-column
              prop="parameter2"
              align="center"
              width="118"
              label="HGP1030">
            </el-table-column>
            <el-table-column
              prop="parameter3"
              align="center"
              width="118"
              label="HGP1050">
            </el-table-column>
            <el-table-column
              prop="parameter4"
              align="center"
              width="118"
              label="HGP1060">
            </el-table-column>
            <el-table-column
              prop="parameter5"
              align="center"
              width="118"
              label="HGP1080">
            </el-table-column>
            <el-table-column
              prop="parameter6"
              align="center"
              width="118"
              label="HGP1001">
            </el-table-column>
            <el-table-column
              prop="parameter7"
              align="center"
              width="118"
              label="HGP1002">
            </el-table-column>
            <el-table-column
              prop="parameter8"
              align="center"
              width="118"
              label="HGP1003">
            </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      url: require('@/assets/images/productCenter/product2.png'),
      cloudDownload: require('@/assets/images/cloud-download.png'),
      isMouseOver: false,
      tableData: [
        {
          project: this.$t('productCenter.common.component'),
          test: '目视',
          parameter1: '有机硅',
          parameter2: '有机硅',
          parameter3: '有机硅',
          parameter4: '有机硅',
          parameter5: '有机硅',
          parameter6: '有机硅',
          parameter7: '有机硅',
          parameter8: '有机硅',
        },
        {
          project: this.$t('productCenter.common.color'),
          test: '-',
          parameter1: '灰色',
          parameter2: '蓝色',
          parameter3: '绿色',
          parameter4: '灰色',
          parameter5: '灰色',
          parameter6: '灰色',
          parameter7: '粉色',
          parameter8: '粉色',
        },
        {
          project: this.$t('productCenter.common.thermalConductivity') + '｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.0',
          parameter2: '3.0',
          parameter3: '5.0',
          parameter4: '6.0',
          parameter5: '8.0',
          parameter6: '10.0',
          parameter7: '12.0',
          parameter8: '13.0',
        },
        {
          project: this.$t('productCenter.common.thickness') + '｜(mm)',
          test: '-',
          parameter1: '0.5~5.0',
          parameter2: '0.5~5.0',
          parameter3: '0.5~5.0',
          parameter4: '0.5~5.0',
          parameter5: '0.5~5.0',
          parameter6: '0.5~5.0',
          parameter7: '0.5~5.0',
          parameter8: '1.0~5.0',
        },
        {
          project: this.$t('productCenter.common.density') + '｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.4',
          parameter2: '3.0',
          parameter3: '3.3',
          parameter4: '3.3',
          parameter5: '3.4',
          parameter6: '3.2',
          parameter7: '3.2',
          parameter8: '3.2',
        },
        {
          project: this.$t('productCenter.common.hardness') + '｜(shore 00)',
          test: 'ASTM D2240',
          parameter1: '35',
          parameter2: '45',
          parameter3: '45',
          parameter4: '45',
          parameter5: '45',
          parameter6: '40',
          parameter7: '30',
          parameter8: '45',
        },
        {
          project: this.$t('productCenter.common.tempRange') + '｜(℃）',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150',
          parameter4: '-40~150',
          parameter5: '-40~150',
          parameter6: '-40~150',
          parameter7: '-40~150',
          parameter8: '-40~150',
        },
        {
          project: this.$t('productCenter.common.dielectricConstant') + '｜@1MHZ',
          test: 'ASTM D150',
          parameter1: '5.5',
          parameter2: '5.5',
          parameter3: '6.5',
          parameter4: '6.3',
          parameter5: '7.9',
          parameter6: '7.8',
          parameter7: '8.0',
          parameter8: '8.0',
        },
        {
          project: this.$t('productCenter.common.volumeResistivity') + '｜(Ω-cm)',
          test: 'ASTM D257',
          parameter1: '10¹³',
          parameter2: '10¹³',
          parameter3: '10¹³',
          parameter4: '10¹³',
          parameter5: '10¹³',
          parameter6: '10¹³',
          parameter7: '10¹³',
          parameter8: '10¹³',
        },
        {
          project: this.$t('productCenter.common.fireRating'),
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0',
          parameter5: 'V-0',
          parameter6: 'V-0',
          parameter7: 'V-0',
          parameter8: 'V-0',
        },
      ],
    }
  },
  computed: {
    productDescription() {
      return '导热垫片是一系列超柔软的高导热性能的热界面材料，在低压力的情况下表现出较小的热阻和很高的形变量，拥有非常好的填缝性能，可使用在公差比较大的平面或大的组装公差填充。在填充不同尺寸间隙的同时，产生非常微弱的回弹应力，最大程度地减小对精密电子器件的冲击。'
    },
    btnText() {
      return this.showcloudDownloadImg ? this.$t('productCenter.downloadManual') : this.$t('productCenter.contactForMore')
    },
    showcloudDownloadImg() {
      return this.isMouseOver ? false : true
    },
    productFeatures() {
      return [
        '导热系数1.0~13W/m-k',
        '超柔软，可压缩10%到70%',
        '高绝缘性',
        '高可靠性',
        '可单面不粘，高撕裂强度处理等'
      ]
    },
    typicalApplications() {
      return [
        '汽车电子及动力电池',
        '大型存储设备',
        '通讯基站设备（4G和5G）',
        '主机和小型办公室网络设备',
        '人工智能数据中心等'
      ]
    }
  },
  methods: {
    mouseenter () {
      this.isMouseOver = true
    },
    mouseleave () {
      this.isMouseOver = false
    }
  }
}
</script>

<style lang="scss" scoped>
.product-detail {
  .product-detail-box {
    padding: 60px 0;
    background: rgb(248, 250, 253);
  }
  .product-detail-title {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    img {
      margin-right: 40px;
    }
    .info {
      .info-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        padding-bottom: 30px;
      }
      .info-text {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        color: rgba(43, 50, 71, 0.7);
        padding-bottom: 30px;
      }
      .el-button {
        background-color: #fff;
        color: rgb(28, 100, 215);
        border-color: rgb(28, 100, 215);
        i {
          display: inline-block;
        }
      }
    }
  }
  .product-detail-info {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 100px;
    .list {
      padding-top: 60px;
      .list-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        padding-bottom: 24px;
      }
      .list-item {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        color: rgba(43, 50, 71, 0.7);
        display: flex;
        align-items: center;
        p {

        }
        span {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: rgba(43, 50, 71, 0.7);
          margin-right: 8px;
        }
      }
    }
    .table {
      padding-top: 60px;
      .table-title {
        margin-bottom: 24px;
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
      }
      ::v-deep .el-table__header th {
        background-color: #f5f7fa;
        text-align: center;
        color: rgb(43, 50, 71);
      }
      ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
        background-color: #f5f7fa;
      }
      ::v-deep .el-table__body td {
        color: rgba(43, 50, 71, 0.7);
      }
      .customTable {
        ::v-deep thead tr:last-child {
          display: none;
        }
      }
      .multiline {
        white-space: pre-line;
        color: rgb(43, 50, 71);
        font-weight: 500;
      }
      .annotation {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        padding-top: 12px;
        color: rgb(43, 50, 71);
      } 
    }
  }
}
</style>